

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Education } from '@/types'

@Component
export default class Educations extends Vue {
  @Prop() educations!: Array<Education>;
}
